/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnintegratedFieldsSchemaEntry } from './UnintegratedFieldsSchemaEntry';
import {
    UnintegratedFieldsSchemaEntryFromJSON,
    UnintegratedFieldsSchemaEntryFromJSONTyped,
    UnintegratedFieldsSchemaEntryToJSON,
    UnintegratedFieldsSchemaEntryToJSONTyped,
} from './UnintegratedFieldsSchemaEntry';
import type { CardSchemesConfiguration } from './CardSchemesConfiguration';
import {
    CardSchemesConfigurationFromJSON,
    CardSchemesConfigurationFromJSONTyped,
    CardSchemesConfigurationToJSON,
    CardSchemesConfigurationToJSONTyped,
} from './CardSchemesConfiguration';

/**
 * 
 * @export
 * @interface PaymentMethodOverridableConfiguration
 */
export interface PaymentMethodOverridableConfiguration {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodOverridableConfiguration
     */
    paymentMethodDisplayLabel?: string;
    /**
     * 
     * @type {Array<UnintegratedFieldsSchemaEntry>}
     * @memberof PaymentMethodOverridableConfiguration
     */
    unintegratedFieldsSchema?: Array<UnintegratedFieldsSchemaEntry>;
    /**
     * 
     * @type {CardSchemesConfiguration}
     * @memberof PaymentMethodOverridableConfiguration
     */
    cardSchemesConfiguration?: CardSchemesConfiguration;
}

/**
 * Check if a given object implements the PaymentMethodOverridableConfiguration interface.
 */
export function instanceOfPaymentMethodOverridableConfiguration(value: object): value is PaymentMethodOverridableConfiguration {
    return true;
}

export function PaymentMethodOverridableConfigurationFromJSON(json: any): PaymentMethodOverridableConfiguration {
    return PaymentMethodOverridableConfigurationFromJSONTyped(json, false);
}

export function PaymentMethodOverridableConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodOverridableConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethodDisplayLabel': json['paymentMethodDisplayLabel'] == null ? undefined : json['paymentMethodDisplayLabel'],
        'unintegratedFieldsSchema': json['unintegratedFieldsSchema'] == null ? undefined : ((json['unintegratedFieldsSchema'] as Array<any>).map(UnintegratedFieldsSchemaEntryFromJSON)),
        'cardSchemesConfiguration': json['cardSchemesConfiguration'] == null ? undefined : CardSchemesConfigurationFromJSON(json['cardSchemesConfiguration']),
    };
}

export function PaymentMethodOverridableConfigurationToJSON(json: any): PaymentMethodOverridableConfiguration {
    return PaymentMethodOverridableConfigurationToJSONTyped(json, false);
}

export function PaymentMethodOverridableConfigurationToJSONTyped(value?: PaymentMethodOverridableConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethodDisplayLabel': value['paymentMethodDisplayLabel'],
        'unintegratedFieldsSchema': value['unintegratedFieldsSchema'] == null ? undefined : ((value['unintegratedFieldsSchema'] as Array<any>).map(UnintegratedFieldsSchemaEntryToJSON)),
        'cardSchemesConfiguration': CardSchemesConfigurationToJSON(value['cardSchemesConfiguration']),
    };
}

